import { AdUnit } from './types';

export const render = (divId: AdUnit['divId']) => {
  return `
    <div id="staticCommercialOverlay">
      <div class="commercialWrapper">
        <div class="commercial" id="${divId}"></div>
      </div>
      <small class="commercialSmallText">annonce</small>
    </div>`;
};
